export function Watermark({ className = "" }) {
  return (
    <svg viewBox="0 0 100 130" fill="none" className={className} aria-hidden="true">
      <path
        d="M50 4 C66 30 88 48 88 76 C88 104 68 124 50 126 C32 124 12 104 12 76 C12 48 34 30 50 4 Z"
        stroke="currentColor"
        strokeWidth="1"
      />
      <path
        d="M50 22 C61 42 74 54 74 76 C74 96 62 108 50 110 C38 108 26 96 26 76 C26 54 39 42 50 22 Z"
        stroke="currentColor"
        strokeWidth="0.75"
        strokeDasharray="2 3"
      />
      <circle cx="50" cy="76" r="5" />
    </svg>
  );
}
